import classNames from 'classnames'
import { merge } from 'lodash'
import React from 'react'

type FilterButtonProps = {
  name: string
  label: string
  filter: object
  setFilter: (filter: object) => void
  removable?: boolean
}

export const FilterButton: React.FC<FilterButtonProps> = ({
  name,
  label,
  filter,
  setFilter,
  removable,
}) => {
  const active = filter[name]

  return (
    <button
      className={classNames('button is-small', {
        'is-active': active,
        'is-info': active,
      })}
      onClick={() =>
        setFilter({ ...filter, [name]: removable ? undefined : !active })
      }
    >
      <span className="icon is-small">
        {removable ? (
          <span className="fa fa-times" />
        ) : active ? (
          <span className="fa fa-check-square" />
        ) : (
          <span className="far fa-square" />
        )}
      </span>
      <span>{label}</span>
    </button>
  )
}

//

type FilterRadioButton = {
  name: string
  label: string
}

type FilterRadioProps = {
  buttons: FilterRadioButton[]
  filter: object
  setFilter: (filter: object) => void
}

export const FilterRadio: React.FC<FilterRadioProps> = ({
  buttons,
  filter,
  setFilter,
}) => {
  const keys = buttons.map(button => button.name).filter(name => name != 'all')
  const values = keys.map(key => filter[key])
  const active = values.every(v => v)
    ? 'all'
    : (keys.find(key => filter[key]) as string)

  return (
    <div className="field has-addons">
      {buttons.map(button => (
        <p className="control" key={button.name}>
          <FilterRadioButton
            {...button}
            active={active == button.name}
            onClick={() => {
              const changed = merge(
                {},
                ...keys.map(key => ({
                  [key]: button.name == 'all' || button.name == key,
                }))
              )

              setFilter({ ...filter, ...changed })
            }}
          />
        </p>
      ))}
    </div>
  )
}

type FilterRadioButtonProps = {
  label: string
  active: boolean
  onClick: () => void
}

const FilterRadioButton: React.FC<FilterRadioButtonProps> = ({
  label,
  active,
  onClick,
}) => {
  return (
    <button
      className={classNames('button is-small', {
        'is-active': active,
        'is-info': active,
      })}
      onClick={onClick}
    >
      <span>{label}</span>
    </button>
  )
}
